import { Injectable } from '@angular/core';
import { PatientGroup } from 'src/app/data/dietitian/domain/patient_group/patient_group';
import { PatientGroupCommands } from 'src/app/data/dietitian/domain/patient_group/patient_group_commands';

@Injectable()
export class PatientGroupsFacade {
  constructor(private patientGroupCommands: PatientGroupCommands) {
    // do nothing
  }

  deletePatientGroup(patientGroupId: string): Promise<PatientGroup> {
    return this.patientGroupCommands.deletePatientGroup(patientGroupId);
  }
}
